import "@babel/polyfill"
import "es6-promise/auto"
import "@/assets/css/style.scss"
import "@fortawesome/fontawesome-free/css/all.css"
import Vue from "vue"

import BootstrapVue from "bootstrap-vue"
import moment from "moment-timezone"
import VueMoment from "vue-moment"
import VueProgressiveImage from "vue-progressive-image"
import Icon from "vue-awesome/components/Icon"

import App from "./App"
import router from "./router"
import { i18n, initializeLocale } from "./i18n"
import { SubHeader } from "./components/mixins/header"
import LImage from "./components/mixins/l-image"
import AppState from "./plugins/appstate"
import Logger from "./plugins/logger"
import vMediaQuery from "v-media-query"
import store from "./api/store"
//import VueFreshchat from "vue-freshchat";

import { func } from "./function"

import "./bootstrap.scss"
import "bootstrap-vue/dist/bootstrap-vue.css"
import "vue-awesome/icons"
import "moment/locale/ko"
import "moment/locale/en-gb"
import "moment/locale/ja"
import "./components/pipes"

// import { library } from "@fortawesome/fontawesome-svg-core"
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
// import { fas } from "@fortawesome/free-solid-svg-icons"
// import { far } from "@fortawesome/free-regular-svg-icons"

// library.add(fas, far)

// Vue.component("f-icon", FontAwesomeIcon)

document.cookie = "LMM_WEBMANAGER_VERSION=;Expires=1544485521178;"

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(VueProgressiveImage)
Vue.use(VueMoment, { moment })

// VueMoment의 moment 필터를 오버라이드하여 UTC → 로컬 타임존 변환 적용.
// format이 'from'/'fromNow'면 상대시간(vue-moment 원래 동작)을 유지한다.
// (format만 지원하면 {{ x | moment('from', ref, true) }}가 format('from')='fro'+분 → "fro0"으로 깨짐)
Vue.filter('moment', (value, format, ref, removeSuffix) => {
  if (!value) return ''
  const local = moment.utc(value).local()
  if (format === 'from') {
    // ref 미지정·'now'면 현재 기준, 그 외엔 기준 시각. removeSuffix=true면 접미사(전/후) 제거.
    const base = (!ref || ref === 'now') ? moment() : moment(ref)
    return local.from(base, removeSuffix === true)
  }
  if (format === 'fromNow') {
    return local.fromNow(ref === true)
  }
  return local.format(format)
})

if (!process.env.VUE_APP_STANDALONE) {
  /*
  Vue.use(VueFreshchat, { appToken: "606dad03-57f2-44d4-82ac-260f35738449" });
  */
}
Vue.component("icon", Icon)
Vue.component("sub-header", SubHeader)
Vue.component("l-image", LImage)

Vue.use(vMediaQuery, {
  methods: {
    isDesktop() {
      return vMediaQuery.methods.above("1024px")
    },
    isTablet() {
      return vMediaQuery.methods.between(["481px", "1024px"])
    },
    isMobile() {
      return vMediaQuery.methods.between(["1px", "480px"])
    },
  },
})

Vue.config.productionTip = false
Vue.prototype.AppState = AppState
Vue.prototype.$log = Logger
Vue.prototype.$func = func

// IndexedDB Storage 초기화 후 앱 시작
store.waitForInitialization()
  .then(() => {
    // IndexedDB 초기화 완료 후 AppState에 저장된 값 로드
    AppState.initializeFromStore(store)

    // store에서 언어 설정 로드
    initializeLocale(store)

    AppState.App = new Vue({
      router,
      i18n,
      render: h => h(App),
    }).$mount("#app")
  })
  .catch(err => {
    console.error("[Main] Storage initialization failed:", err)
    // 초기화 실패해도 앱은 시작 (빈 캐시로 작동)
    AppState.App = new Vue({
      router,
      i18n,
      render: h => h(App),
    }).$mount("#app")
  })
